if (!customElements.get('collection-mega-menu-v2')) {
  class CollectionMegaMenuV2 extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-collection-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-collection-panel]'));
      this.title = this.querySelector('[data-collection-title]');
      this.viewAll = this.querySelector('[data-collection-view-all]');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.querySelectorAll('[data-collection-variant-option]').forEach((option) => {
        option.addEventListener('change', () => this.onVariantChange(option));
      });
    }

    selectTab(index, focus = false) {
      const selectedTab = this.tabs[index];
      if (!selectedTab) return;

      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      if (this.title) this.title.textContent = selectedTab.dataset.title;
      if (this.viewAll && !this.viewAll.dataset.fixedUrl) this.viewAll.href = selectedTab.dataset.url;
      if (focus) selectedTab.focus();
    }

    onKeydown(event, index) {
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();

      let nextIndex = index;
      if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      this.selectTab(nextIndex, true);
    }

    onVariantChange(option) {
      const productCard = option.closest('.horizontal-product');
      const submitButton = option.form?.querySelector('[data-collection-variant-submit]');
      if (productCard) productCard.dataset.laDnProductVariant = option.value;
      if (submitButton) submitButton.dataset.variantId = option.value;
    }
  }

  customElements.define('collection-mega-menu-v2', CollectionMegaMenuV2);
}

if (!window.collectionMegaV2VariantListener) {
  window.collectionMegaV2VariantListener = true;
  document.addEventListener('change', (event) => {
    const option = event.target.closest('[data-collection-variant-option]');
    if (!option) return;

    const productCard = option.closest('.horizontal-product');
    const submitButton = option.form?.querySelector('[data-collection-variant-submit]');
    if (productCard) productCard.dataset.laDnProductVariant = option.value;
    if (submitButton) submitButton.dataset.variantId = option.value;
  });
}
